 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACK_COVER_TEXT from '@/components/Back_Cover_Text'
 import TITLE_PAGE from '@/components/Title_Page'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import CHAPTER_ONE from '@/components/Chapter_One'
 import CHAPTER_TWO from '@/components/Chapter_Two'
 import CHAPTER_THREE from '@/components/Chapter_Three'
 import CHAPTER_FOUR from '@/components/Chapter_Four'
 import CHAPTER_FIVE from '@/components/Chapter_Five'
 import CHAPTER_SIX from '@/components/Chapter_Six'
 import CHAPTER_SEVEN from '@/components/Chapter_Seven'
 import CHAPTER_EIGHT from '@/components/Chapter_Eight'
 import CHAPTER_NINE from '@/components/Chapter_Nine'
 import CHAPTER_TEN from '@/components/Chapter_Ten'
 import CHAPTER_ELEVEN from '@/components/Chapter_Eleven'
 import CHAPTER_TWELVE from '@/components/Chapter_Twelve'
 import CHAPTER_THIRTEEN from '@/components/Chapter_Thirteen'
 import CHAPTER_FOURTEEN from '@/components/Chapter_Fourteen'
 import CHAPTER_FIFTEEN from '@/components/Chapter_Fifteen'
 import CHAPTER_SIXTEEN from '@/components/Chapter_Sixteen'
 import CHAPTER_SEVENTEEN from '@/components/Chapter_Seventeen'
 import CHAPTER_EIGHTEEN from '@/components/Chapter_Eighteen'
 import CHAPTER_NINETEEN from '@/components/Chapter_Nineteen'
 import CHAPTER_TWENTY from '@/components/Chapter_Twenty'
 import CHAPTER_TWENTYONE from '@/components/Chapter_Twenty-One'
 import CHAPTER_TWENTYTWO from '@/components/Chapter_Twenty-Two'
 import CHAPTER_TWENTYTHREE from '@/components/Chapter_Twenty-Three'
 import CHAPTER_TWENTYFOUR from '@/components/Chapter_Twenty-Four'
 import CHAPTER_TWENTYFIVE from '@/components/Chapter_Twenty-Five'
 import CHAPTER_TWENTYSIX from '@/components/Chapter_Twenty-Six'
 import CHAPTER_TWENTYSEVEN from '@/components/Chapter_Twenty-Seven'
 import CHAPTER_TWENTYEIGHT from '@/components/Chapter_Twenty-Eight'
 import CHAPTER_TWENTYNINE from '@/components/Chapter_Twenty-Nine'
 import CHAPTER_THIRTY from '@/components/Chapter_Thirty'
 import CHAPTER_THIRTYONE from '@/components/Chapter_Thirty-One'
 import CHAPTER_THIRTYTWO from '@/components/Chapter_Thirty-Two'
 import CHAPTER_THIRTYTHREE from '@/components/Chapter_Thirty-Three'
 import CHAPTER_THIRTYFOUR from '@/components/Chapter_Thirty-Four'
 import CHAPTER_THIRTYFIVE from '@/components/Chapter_Thirty-Five'
 import CHAPTER_THIRTYSIX from '@/components/Chapter_Thirty-Six'
 import CHAPTER_THIRTYSEVEN from '@/components/Chapter_Thirty-Seven'
 import CHAPTER_THIRTYEIGHT from '@/components/Chapter_Thirty-Eight'
 import CHAPTER_THIRTYNINE from '@/components/Chapter_Thirty-Nine'
 import CHAPTER_FORTY from '@/components/Chapter_Forty'
 import CHAPTER_FORTYONE from '@/components/Chapter_Forty-One'
 import CHAPTER_FORTYTWO from '@/components/Chapter_Forty-Two'
 import CHAPTER_FORTYTHREE from '@/components/Chapter_Forty-Three'
 import CHAPTER_FORTYFOUR from '@/components/Chapter_Forty-Four'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Chapter_One",
 			"name" : "Chapter_One",
 			"component" : CHAPTER_ONE
 		},
 		{
 			"path" : "/Chapter_Two",
 			"name" : "Chapter_Two",
 			"component" : CHAPTER_TWO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js